<template>
  <ul>
    <app-order-item v-for="o in lists" :key="o.order_num" :o="o"></app-order-item>
  </ul>
</template>

<script>
/* eslint-disable */
import AppOrderItem from './AppOrderItem.vue'
export default {
  name: 'AppOrderList',
  props: ['lists'],
  components: { AppOrderItem },
  computed: {
    
  },
  data() {
    return {
    }
  },
  methods: {
    
  },
  created() {
  }
}
</script>

<style scoped lang="scss">

</style>
